import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.eval');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-eval',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.eval/view.scss */
/* src/app/page.eval/view.scss: no such file or directory */`],
})
export class PageEvalComponent implements OnInit {
    public loading: boolean = true;
    public actionLoading: boolean = false;
    public error: string = '';
    public cards: any[] = [];
    public summary: any = {};
    public sourceDatasets: any[] = [];
    public approvedItems: any[] = [];
    public evalSets: any[] = [];
    public evalRuns: any[] = [];
    public goldenSets: any[] = [];
    public goldenItems: any[] = [];
    public threshold: number = 0.8;
    public lockLimit: number = 200;
    public exportPurpose: string = 'eval';
    public exportFormat: string = 'jsonl';
    public exportCounts: any = {};
    public exportLoading: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.error = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("overview", { limit: 100 });
            if (code === 200) {
                this.summary = data.summary || {};
                this.cards = data.cards || [];
                this.sourceDatasets = data.source_datasets || [];
                this.approvedItems = data.approved_items || [];
                this.evalSets = data.eval_sets || [];
                this.evalRuns = data.eval_runs || [];
                this.goldenSets = data.golden_sets || [];
                this.goldenItems = data.golden_items || [];
                this.exportCounts = data.export_counts || {};
            } else {
                this.error = data?.message || '평가/골든셋 현황을 불러오지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '평가/골든셋 현황을 불러오지 못했습니다.';
        }

        this.loading = false;
        await this.service.render();
    }

    public async lockEvalSet(source?: any) {
        const datasetId = source?.id || '';
        const targetLabel = source?.name || '전체 승인 QA';
        const readyCount = Number(source?.ready_count ?? this.summary.approved_unlocked ?? 0);
        if (readyCount < 1) {
            await this.service.modal.error('평가셋으로 확정할 승인 QA가 없습니다.');
            return;
        }

        const confirmed = await this.service.modal.show({
            title: '평가셋 확정',
            message: `${targetLabel}에서 승인 QA ${this.number(readyCount)}개를 평가 처리 실행 대상으로 잠그시겠습니까?`,
            action: '확정',
            status: 'success'
        });
        if (!confirmed) return;

        this.actionLoading = true;
        await this.service.render();

        const { code, data } = await wiz.call("lock_eval_set", {
            dataset_id: datasetId,
            limit: this.lockLimit
        });
        if (code === 200) {
            const locked = data?.result?.locked_count || 0;
            await this.service.modal.success(`평가셋 ${this.number(locked)}개 항목을 확정했습니다.`);
            await this.load();
        } else {
            await this.service.modal.error(data?.message || '평가셋 확정에 실패했습니다.');
        }

        this.actionLoading = false;
        await this.service.render();
    }

    public async runEval(dataset: any) {
        if (!dataset?.id) return;
        const confirmed = await this.service.modal.show({
            title: '평가 실행',
            message: `${dataset.name || dataset.id} 평가셋을 통과 기준 ${this.threshold}로 실행하시겠습니까?`,
            action: '실행',
            status: 'success'
        });
        if (!confirmed) return;

        this.actionLoading = true;
        await this.service.render();

        const { code, data } = await wiz.call("run_eval", {
            dataset_id: dataset.id,
            threshold: this.threshold
        });
        if (code === 200) {
            await this.service.modal.success('평가 실행을 완료했습니다.');
            await this.load();
        } else {
            await this.service.modal.error(data?.message || '평가 실행에 실패했습니다.');
        }

        this.actionLoading = false;
        await this.service.render();
    }

    public async publishGolden(run: any) {
        if (!run?.id) return;
        const confirmed = await this.service.modal.show({
            title: '골든셋 확정',
            message: `${run.dataset_name || run.dataset_id} 평가 결과 중 통과 항목 ${this.number(run.completed_cases)}건만 골든셋으로 확정하시겠습니까?`,
            action: '확정',
            status: 'success'
        });
        if (!confirmed) return;

        this.actionLoading = true;
        await this.service.render();

        const { code, data } = await wiz.call("publish_golden", { eval_id: run.id });
        if (code === 200) {
            await this.service.modal.success('골든셋을 확정했습니다.');
            await this.load();
        } else {
            await this.service.modal.error(data?.message || '골든셋 확정에 실패했습니다.');
        }

        this.actionLoading = false;
        await this.service.render();
    }

    public async exportDataset() {
        if (this.exportLoading) return;
        this.exportLoading = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call("export_dataset", {
                purpose: this.exportPurpose || 'eval',
                format: this.exportFormat || 'jsonl',
                limit: 10000
            });
            if (code === 200) {
                const payload = data?.export || {};
                this.downloadText(payload.content || '', payload.filename || 'qa-export.jsonl', payload.mime_type || 'text/plain;charset=utf-8');
                await this.service.modal.success(`QA 후보 ${this.number(payload.record_count)}건을 내보냈습니다.`);
            } else {
                await this.service.modal.error(data?.message || 'QA 후보 내보내기에 실패했습니다.');
            }
        } catch (error: any) {
            await this.service.modal.error(error?.message || 'QA 후보 내보내기에 실패했습니다.');
        }

        this.exportLoading = false;
        await this.service.render();
    }

    public downloadText(content: string, filename: string, mimeType: string) {
        const blob = new Blob([content || ''], { type: mimeType || 'text/plain;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = filename || 'qa-export.jsonl';
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        setTimeout(() => URL.revokeObjectURL(url), 0);
    }

    public number(value: any) {
        return Number(value || 0).toLocaleString();
    }

    public score(value: any) {
        return Number(value || 0).toFixed(3);
    }

    public itemScore(item: any) {
        return this.score(Number(item?.review_score || item?.auto_score || 0));
    }

    public shortId(value: any) {
        value = String(value || '');
        if (!value) return '-';
        return value.length > 10 ? value.slice(0, 8) : value;
    }

    public date(value: any) {
        if (!value) return '-';
        return String(value).slice(0, 16);
    }

    public canRunDataset(dataset: any) {
        return !!dataset?.locked_at && Number(dataset?.item_count || 0) > 0;
    }

    public canPublish(run: any) {
        return run?.status === 'completed' && Number(run?.completed_cases || 0) > 0 && Number(run?.total_cases || 0) > 0;
    }

    public splitLabel(value: string) {
        switch (value) {
            case 'approved_pool': return '평가 후보';
            case 'eval_set': return '평가셋';
            case 'golden_set': return '골든셋';
            default: return value || '-';
        }
    }

    public splitClass(value: string) {
        switch (value) {
            case 'train': return 'bg-emerald-50 text-emerald-700 border-emerald-200';
            case 'eval': return 'bg-indigo-50 text-indigo-700 border-indigo-200';
            case 'golden': return 'bg-amber-50 text-amber-700 border-amber-200';
            case 'approved_pool': return 'bg-sky-50 text-sky-700 border-sky-200';
            case 'eval_set': return 'bg-indigo-50 text-indigo-700 border-indigo-200';
            case 'golden_set': return 'bg-amber-50 text-amber-700 border-amber-200';
            default: return 'bg-gray-50 text-gray-600 border-gray-200';
        }
    }

    public approvalLabel(value: string) {
        switch (value) {
            case 'approved': return '승인 완료';
            case 'rejected': return '반려';
            case 'change_requested': return '수정 요청';
            default: return value || '-';
        }
    }

    public evidenceLabel(item: any) {
        return item?.evidence_connected ? '연결됨' : '누락';
    }

    public evidenceClass(item: any) {
        return item?.evidence_connected
            ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
            : 'bg-rose-50 text-rose-700 border-rose-200';
    }

    public qualityLabel(value: any) {
        value = String(value || '');
        switch (value) {
            case 'ready':
            case 'passed':
            case 'completed':
            case 'indexed':
            case 'ok':
                return '정상';
            case 'unchecked':
            case '':
                return '미확인';
            case 'failed':
            case 'missing':
            case 'error':
                return '점검 필요';
            default:
                return value;
        }
    }

    public qualityClass(value: any) {
        value = String(value || '');
        switch (value) {
            case 'ready':
            case 'passed':
            case 'completed':
            case 'indexed':
            case 'ok':
                return 'bg-emerald-50 text-emerald-700 border-emerald-200';
            case 'failed':
            case 'missing':
            case 'error':
                return 'bg-rose-50 text-rose-700 border-rose-200';
            default:
                return 'bg-gray-50 text-gray-600 border-gray-200';
        }
    }

    public statusLabel(status: string) {
        switch (String(status || '')) {
            case 'completed': return '완료';
            case 'passed': return '통과';
            case 'published': return '게시';
            case 'locked': return '확정';
            case 'approved': return '승인';
            case 'golden_locked': return '골든 확정';
            case 'running': return '실행 중';
            case 'evaluating': return '평가 중';
            case 'eval_candidate': return '평가 후보';
            case 'queued': return '대기';
            case 'draft': return '초안';
            case 'failed': return '실패';
            case 'blocked': return '보류';
            case 'rejected': return '반려';
            default: return status || '-';
        }
    }

    public statusClass(status: string) {
        switch (status) {
            case 'completed':
            case 'passed':
            case 'published':
            case 'locked':
            case 'approved':
            case 'golden_locked':
                return 'bg-emerald-50 text-emerald-700 border-emerald-200';
            case 'running':
            case 'evaluating':
            case 'eval_candidate':
                return 'bg-indigo-50 text-indigo-700 border-indigo-200';
            case 'queued':
            case 'draft':
                return 'bg-amber-50 text-amber-700 border-amber-200';
            case 'failed':
            case 'blocked':
            case 'rejected':
                return 'bg-rose-50 text-rose-700 border-rose-200';
            default:
                return 'bg-gray-50 text-gray-600 border-gray-200';
        }
    }

    public exportPurposeLabel(value: string) {
        switch (value) {
            case 'eval': return '평가셋';
            case 'golden': return '골든셋';
            case 'all': return '전체';
            default: return value || '-';
        }
    }

    public exportCount(value: string) {
        return Number(this.exportCounts?.[value] || 0);
    }

    public toneClass(tone: string) {
        switch (tone) {
            case 'green': return 'bg-emerald-50 text-emerald-700 border-emerald-100';
            case 'amber': return 'bg-amber-50 text-amber-700 border-amber-100';
            case 'indigo': return 'bg-indigo-50 text-indigo-700 border-indigo-100';
            case 'blue': return 'bg-sky-50 text-sky-700 border-sky-100';
            default: return 'bg-gray-50 text-gray-600 border-gray-100';
        }
    }
}

export default PageEvalComponent;